import t10 from "../assets/images/photographyPage/t1/t10.jpg";
import t11 from "../assets/images/photographyPage/t1/t11.jpg";
import t12 from "../assets/images/photographyPage/t1/t12.jpg";
import t13 from "../assets/images/photographyPage/t1/t13.jpg";

import t20 from "../assets/images/photographyPage/t2/t20.jpg";
import t21 from "../assets/images/photographyPage/t2/t21.jpg";
import t22 from "../assets/images/photographyPage/t2/t22.jpg";
import t23 from "../assets/images/photographyPage/t2/t23.jpg";

import t30 from "../assets/images/photographyPage/t3/t30.jpg";
import t31 from "../assets/images/photographyPage/t3/t31.jpg";
import t32 from "../assets/images/photographyPage/t3/t32.jpg";
import t33 from "../assets/images/photographyPage/t3/t33.jpg";

import t40 from "../assets/images/photographyPage/t4/t40.jpg";
import t41 from "../assets/images/photographyPage/t4/t41.jpg";
import t42 from "../assets/images/photographyPage/t4/t42.jpg";
import t43 from "../assets/images/photographyPage/t4/t43.jpg";

const MoviePageArray = [
  {
    movieTopic: "Director",
    images: [
      {
        imageName: "ON DRY GRASS",
        imageURL: t10,
      },
      {
        imageName: "A LONG COLD WINTER",
        imageURL: t11,
      },
      {
        imageName: "THREE MONKEYS",
        imageURL: t12,
      },
      {
        imageName: "CLOUDS OF MAY",
        imageURL: t13,
      },
    ],
  },
  {
    movieTopic: "Screenwriter",
    images: [
      {
        imageName: "ON DRY GRASS",
        imageURL: t20,
      },
      {
        imageName: "A LONG COLD WINTER",
        imageURL: t21,
      },
      {
        imageName: "THREE MONKEYS",
        imageURL: t22,
      },
      {
        imageName: "CLOUDS OF MAY",
        imageURL: t23,
      },
    ],
  },
  {
    movieTopic: "Editor",
    images: [
      {
        imageName: "ON DRY GRASS",
        imageURL: t30,
      },
      {
        imageName: "A LONG COLD WINTER",
        imageURL: t31,
      },
      {
        imageName: "THREE MONKEYS",
        imageURL: t32,
      },
      {
        imageName: "CLOUDS OF MAY",
        imageURL: t33,
      },
    ],
  },
  {
    movieTopic: "Cinematographer",
    images: [
      {
        imageName: "ON DRY GRASS",
        imageURL: t40,
      },
      {
        imageName: "A LONG COLD WINTER",
        imageURL: t41,
      },
      {
        imageName: "THREE MONKEYS",
        imageURL: t42,
      },
      {
        imageName: "CLOUDS OF MAY",
        imageURL: t43,
      },
    ],
  },
];

export default MoviePageArray;
